import { render, staticRenderFns } from "./uni-card.vue?vue&type=template&id=572dbb6b&scoped=true"
import script from "./uni-card.vue?vue&type=script&lang=js"
export * from "./uni-card.vue?vue&type=script&lang=js"
import style0 from "./uni-card.vue?vue&type=style&index=0&id=572dbb6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572dbb6b",
  null
  
)

export default component.exports